import { render, staticRenderFns } from "./stripe-test-return.vue?vue&type=template&id=a1445132&scoped=true"
import script from "./stripe-test-return.vue?vue&type=script&lang=js"
export * from "./stripe-test-return.vue?vue&type=script&lang=js"
import style0 from "./stripe-test-return.vue?vue&type=style&index=0&id=a1445132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1445132",
  null
  
)

export default component.exports